import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, crudUpdateMany } from "react-admin";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class BulkAction extends Component {
  handleClick = () => {
    const { basePath, crudUpdateMany, resource, selectedIds } = this.props;
    crudUpdateMany(resource, selectedIds, { Status: "REJECTED" }, basePath);
  };

  render() {
    return (
      <Button label="Reject" onClick={this.handleClick}>
        <FontAwesomeIcon icon="ban" />
      </Button>
    );
  }
}

export default connect(
  undefined,
  { crudUpdateMany }
)(BulkAction);
